export function declOfNum(number: number, titles: string[]) {
  if (Math.abs(number) === 1) {
    return titles[0];
  }

  return titles[1] ?? titles[2] ?? titles[0];
}
